import { Suspense, lazy } from 'react';

import { useAltFeature } from '@spotify/confidence-core-react';

import { IdentityAvatarBase, IdentityAvatarProps } from './IdentityAvatarBase';

const IdentityAvatarPortal = lazy(() => import('./IdentityAvatarPortal'));

export const IdentityAvatar = (props: IdentityAvatarProps) => {
  const isPortal = useAltFeature('core.auth') === 'portal';

  if (isPortal) {
    return (
      <Suspense fallback={null}>
        <IdentityAvatarPortal {...props} />
      </Suspense>
    );
  }

  return (
    <IdentityAvatarBase
      {...props}
      avatarSrc={props.identityRef?.pictureUri || undefined}
    />
  );
};
